import script from "./agentWithdrawList.vue?vue&type=script&setup=true&lang=js"
export * from "./agentWithdrawList.vue?vue&type=script&setup=true&lang=js"

import "./agentWithdrawList.vue?vue&type=style&index=0&id=7043e2a6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7043e2a6"]])

export default __exports__